import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Boton from '@components/Boton';
import TituloAdmin from '@components/TituloAdmin';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { colors } from '@styles/colors';
import Label from '@components/Label';
import { tablaEstylos, tablaTheadEstylos, tdStyle, trStyle, thStyle } from '@styles/tablaEstylos';
import { API_HOST } from '@utils/const';
import Input from '@components/Input';
import { selectStyle } from '@styles/selecsEstylos';
import '@styles/select2Custom.css';
import '@styles/modernTable.css';
import Notify from '@components/Notify';
import BotonIconoTabla from '@components/BotonIconoTabla';
import LoadingOverlay from '@components/LoadingOverlay';
import LabelCarga from '@components/LabelCarga';

import { getAllMedicosApi, createMedicoApi, updateMedicoApi, deleteMedicoApi, uploadMedicoPhotoApi, updateMedicoSpecialtiesApi, viewMedicosApi } from '@api/wp/medicos/medicosApi';
import { getAllEspecialidadesApi } from '@api/wp/especialidades/especialidadesApi';

const SpecialtySelect = ({ initialValue, options, onSave }) => {
  const selectRef = useRef(null);
  const [selectedData, setSelectedData] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    const $ = window.$;
    if (!$ || !selectRef.current) return;
    const $el = $(selectRef.current);

    let selectedIds = [];
    if (initialValue) {
      const values = initialValue.split(',').map(v => v.trim().toLowerCase());
      values.forEach(v => {
        if (!v) return;
        const exact = options.find(o => o.label.toLowerCase().trim() === v);
        if (exact) {
          selectedIds.push(exact.value);
        } else {
          const partial = options.find(o => o.label.toLowerCase().startsWith(v + ' -'));
          if (partial) selectedIds.push(partial.value);
        }
      });
    }

    $el.select2({
      width: '100%',
      minimumResultsForSearch: 0,
      placeholder: "-- Seleccione --",
      allowClear: true
    });

    if (selectedIds.length > 0) {
      $el.val(selectedIds).trigger('change.select2');
      // Initialize internal state to match initial value
      // We need the full data objects, not just IDs, but select2 'data' gives current selection
      // However, immediately after init, we can get data.
      setTimeout(() => {
        setSelectedData($el.select2('data'));
      }, 0);
    }

    $el.on('change', function (e) {
      const data = $el.select2('data');
      setSelectedData(data);
      setHasChanged(true);
    });

    return () => {
      if ($el.data('select2')) {
        $el.select2('destroy');
        $el.off('change');
      }
    };
  }, [options, initialValue]);

  const handleSave = () => {
    onSave(selectedData);
    setHasChanged(false);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div style={{ flex: 1 }}>
        <select ref={selectRef} style={{ width: '100%' }} multiple>
          {options.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
      {hasChanged && (
        <IconButton
          onClick={handleSave}
          size="small"
          style={{ backgroundColor: colors.primary, color: 'white', padding: '4px' }}
          title="Guardar cambios"
        >
          <CheckIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

function Medicos() {
  const navigate = useNavigate();
  const [medicos, setMedicos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [cargandoFoto, setCargandoFoto] = useState(false);
  const [renderingTable, setRenderingTable] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(null);
  const [exitoModalOpen, setExitoModalOpen] = useState(false);
  const [fotoPreview, setFotoPreview] = useState(null);
  const [subiendoFoto, setSubiendoFoto] = useState(false);
  const [errorFoto, setErrorFoto] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [especialidades, setEspecialidades] = useState([]);
  const [form, setForm] = useState({ oid_medico: '', nombre: '', formacion: '', especialidad: null, experiencia: '', resenas: '', telefono: '', estado: 0 });
  const [editId, setEditId] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [busquedaEmpresa, setBusquedaEmpresa] = useState('');
  const [busquedaEspecialidad, setBusquedaEspecialidad] = useState('');
  const [filtroSinEspecialidad, setFiltroSinEspecialidad] = useState('todos');
  const [notification, setNotification] = useState({ open: false, message: '', type: 'success' });

  const tablaRef = useRef(null);
  const fileInputRef = useRef(null);
  const filtroAsignacionSelectRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);


  const inputStyle = { width: '100%', padding: '1.2vh', fontSize: '1.7vh', borderRadius: '0.8vh', border: `0.2vh solid ${colors.gray400}` };
  const labelStyle = { fontFamily: 'Inter', fontSize: '1.7vh', marginBottom: '0.8vh', display: 'block', color: colors.gray600 };
  const alertStyle = (type) => ({ padding: '1.5vh 2vh', marginBottom: '2vh', borderRadius: '0.8vh', fontSize: '1.4vh', fontWeight: '500', fontFamily: 'Inter', border: `1px solid ${type === 'error' ? colors.errorText : colors.primary}`, backgroundColor: type === 'error' ? colors.errorShadow : colors.resumenBg, color: type === 'error' ? colors.errorText : colors.primaryText });

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  const cargarMedicos = async () => {
    // Función reutilizada para refrescar lista después de editar/crear
    if (!busqueda && !busquedaEmpresa && !busquedaEspecialidad) {
      setMedicos([]);
      return;
    }
    setCargando(true);
    try {
      const payload = {
        nombre: busqueda || undefined,
        empresa: busquedaEmpresa || undefined,
        especialidad: busquedaEspecialidad || undefined
      };
      const resp = await viewMedicosApi(payload);
      setMedicos(resp.result || []);
    } catch (e) {
      console.error(e);
      setMedicos([]);
    } finally {
      setCargando(false);
    }
  };

  const handleSpecialtyChange = async (medico, selectedOptions) => {
    setProcesando(true);
    try {
      const specialtyIds = selectedOptions ? selectedOptions.map(o => o.id) : [];
      await updateMedicoSpecialtiesApi(medico.id, specialtyIds);
      setNotification({ open: true, message: 'Guardado exitoso', type: 'success' });
    } catch (e) {
      console.error(e);
      setNotification({ open: true, message: 'Error al actualizar especialidad', type: 'error' });
    } finally {
      setProcesando(false);
    }
  };

  useEffect(() => {
    const cargarDatos = async () => {
      // Solo cargar especialidades inicialmente
      setCargando(true);
      setError(null);
      try {
        const espResp = await getAllEspecialidadesApi();
        setEspecialidades(espResp.result.map(e => ({ value: e.id, label: `${e.nombre_especialidad} - ${e.nombre_empresa}` })));
        setMedicos([]); // Iniciar vacío
      } catch (e) {
        console.error(e);
        setError('Error al cargar datos iniciales');
      } finally {
        setCargando(false);
      }
    };
    cargarDatos();
  }, []);

  // Select2 — mismo criterio que CitasExtras.jsx (Filtrar por Asignación).
  // El <select> solo existe cuando cargando === false; si el efecto corre solo con [],
  // tras la carga inicial el nodo se desmonta y vuelve a montar sin Select2.
  useEffect(() => {
    if (cargando) {
      return undefined;
    }
    try {
      const $ = window.$;
      if (!filtroAsignacionSelectRef.current || !$?.fn?.select2) {
        return undefined;
      }
      const $el = $(filtroAsignacionSelectRef.current);
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.off('change.select2react');
        $el.select2('destroy');
      }
      $el.select2({
        placeholder: '-- Filtrar por asignación --',
        allowClear: false,
        width: '100%',
        theme: 'default',
        minimumResultsForSearch: 0,
        language: {
          noResults: function () { return 'No se encontraron resultados'; },
          searching: function () { return 'Buscando...'; },
        },
      });
      $el.on('change.select2react', function () {
        setFiltroSinEspecialidad(String($el.val() || 'todos'));
      });
      $el.val(String(filtroSinEspecialidad)).trigger('change');
      return () => {
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }
      };
    } catch (e) {
      console.error('Error inicializando Select2 (filtrar asignación):', e);
      return undefined;
    }
  }, [cargando]);

  useEffect(() => {
    try {
      const $ = window.$;
      const el = filtroAsignacionSelectRef.current;
      if (!el || !$?.fn?.select2) return;
      const $el = $(el);
      if (!$el.hasClass('select2-hidden-accessible')) return;
      const next = String(filtroSinEspecialidad);
      if ($el.val() !== next) {
        $el.val(next).trigger('change');
      }
    } catch (_) {
      /* noop */
    }
  }, [filtroSinEspecialidad]);

  // Efecto para buscar médicos cuando cambian los filtros - REMOVED per user request
  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(async () => {
  //     // Si hay criterios de búsqueda, consultar al servidor
  //     if (busqueda || busquedaEmpresa || busquedaEspecialidad) {
  //       setCargando(true);
  //       try {
  //         const payload = {
  //           nombre: busqueda || undefined,
  //           empresa: busquedaEmpresa || undefined,
  //           especialidad: busquedaEspecialidad || undefined
  //         };
  //         const resp = await viewMedicosApi(payload);
  //         setMedicos(resp.result || []);
  //       } catch (error) {
  //         console.error("Error buscando médicos:", error);
  //         setMedicos([]);
  //       } finally {
  //         setCargando(false);
  //       }
  //     } else {
  //       // Si no hay búsqueda, limpiar la tabla
  //       setMedicos([]);
  //     }
  //   }, 600); // 600ms debounce

  //   return () => clearTimeout(delayDebounceFn);
  // }, [busqueda, busquedaEmpresa, busquedaEspecialidad]);

  const descargarExcel = () => {
    try {
      const headers = ['Nombre', 'Especialidad', 'Telefonos', 'Ciudad'];
      const datos = Array.isArray(medicos) ? medicos : [];

      const filas = datos.map((item) => [
        item?.nombre ?? 'N/A',
        item?.especialidad ?? 'N/A',
        item?.telefono ?? 'N/A',
        item?.ciudad_contratante ?? 'N/A',
      ]);

      const sep = ';'; // separador recomendado para Excel en configuración regional ES
      const esc = (val) => {
        const s = String(val).replace(/"/g, '""');
        return `"${s}"`;
      };

      let contenido = '\uFEFF'; // BOM para UTF-8, mejora compatibilidad con Excel
      contenido += headers.map(esc).join(sep) + '\r\n';
      for (const fila of filas) {
        contenido += fila.map(esc).join(sep) + '\r\n';
      }

      const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const fecha = new Date().toISOString().slice(0, 10);
      a.href = url;
      a.download = `medicos_${fecha}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Error al exportar Excel (CSV):', e);
    }
  };


  const handleChange = (e) => { const { name, value } = e.target; setForm((prev) => ({ ...prev, [name]: value })); };

  const handleSave = async () => {
    if (!form.nombre || form.nombre.trim() === '') { setError('El nombre es requerido'); return; }
    setProcesando(true); setError(null); setExito(null);
    try {
      // Construir payload limpio según esquema del servidor
      const payload = {
        nombre: form.nombre || undefined,
        iden: form.iden || undefined,
        formacion: form.formacion || undefined,
        especialidad: form.especialidad || '',
        experiencia: form.experiencia || undefined,
        resenas: form.resenas || undefined,
        telefono: form.telefono || undefined,
        estado: form.estado || 0
      };
      // Incluir oid_medico solo si viene con valor
      if (form.oid_medico !== '' && form.oid_medico !== null && form.oid_medico !== undefined) {
        const oid = parseInt(form.oid_medico, 10);
        if (!Number.isNaN(oid)) payload.oid_medico = oid;
      }

      if (editId) {
        await updateMedicoApi(editId, payload);
        // Actualizar registro en memoria con los valores actuales del formulario
        setMedicos((prev) => prev.map((m) => {
          if (m.id !== editId) return m;
          return {
            ...m,
            oid_medico: payload.oid_medico ?? '',
            iden: form.iden || '',
            nombre: (form.nombre || '').trim(),
            formacion: form.formacion || '',
            especialidad: payload.especialidad,
            experiencia: form.experiencia || '',
            resenas: form.resenas || '',
            telefono: form.telefono || '',
            estado: form.estado || 0
          };
        }));
        setExito('Médico actualizado');
        setExitoModalOpen(true);
      } else {
        const resp = await createMedicoApi(payload);
        // Insertar nuevo registro en memoria con los valores actuales
        const nuevo = {
          id: resp?.result?.id ?? Math.random(),
          oid_medico: payload.oid_medico ?? '',
          iden: form.iden || '',
          nombre: (form.nombre || '').trim(),
          formacion: form.formacion || '',
          especialidad: payload.especialidad,
          experiencia: form.experiencia || '',
          resenas: form.resenas || '',
          telefono: form.telefono || '',
          estado: form.estado || 0
        };
        setMedicos((prev) => [nuevo, ...prev]);
        setExito('Médico creado');
        setExitoModalOpen(true);
      }
      setEditId(null);
      setModalOpen(false);
    } catch (e) {
      console.error('Error guardando médico:', e);
      const msg = e?.message || e?.error || 'No se pudo guardar el médico';
      setError(typeof msg === 'string' ? msg : 'No se pudo guardar el médico');
    }
    finally { 
      setProcesando(false);
      setRenderingTable(true);
      setTimeout(() => setRenderingTable(false), 1000);
    }
  };

  const handlePhotoChange = async (e) => {
    try {
      setErrorFoto(null);
      const file = e.target.files?.[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        setErrorFoto('Selecciona un archivo de imagen');
        return;
      }
      // Validar que exista el ID del registro en oficina_medicos (editId)
      if (!editId) {
        setErrorFoto('Primero guarda el médico para obtener su ID');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = async () => {
        const dataUrl = reader.result;
        setFotoPreview(dataUrl);
        setSubiendoFoto(true);
        try {
          // Enviar imagen en base64 y asociarla al ID (oficina_medicos.id)
          const payload = { data: String(dataUrl), medicoId: Number(editId) };
          const resp = await uploadMedicoPhotoApi(payload);
          if (resp?.result?.url) {
            setExito(`Foto del médico guardada`);
          } else {
            setExito('Foto del médico guardada correctamente');
          }
          setExitoModalOpen(true);
        } catch (err) {
          console.error(err);
          setErrorFoto('No se pudo subir la foto');
        } finally {
          setSubiendoFoto(false);
        }
      };
      reader.readAsDataURL(file);
    } catch (err) {
      console.error(err);
      setErrorFoto('Error procesando la imagen');
    }
  };

  // Intentar cargar la foto guardada si existe (por ID del médico)
  const cargarFotoGuardada = async (idMedico) => {
    setCargandoFoto(true);
    try {
      // Derivar bases sin "/api" y probar alternativas de puerto y origen
      const API_BASE = String(API_HOST).replace(/\/(api)$/i, '');
      const bases = [API_BASE];
      if (/localhost:3001/i.test(API_BASE)) bases.push(API_BASE.replace(':3001', ':3000'));
      if (typeof window !== 'undefined' && window.location?.origin && !bases.includes(window.location.origin)) {
        bases.push(window.location.origin);
      }
      const exts = ['jpg', 'jpeg', 'png', 'webp'];

      for (const base of bases) {
        for (const ext of exts) {
          const url = `${base}/public/medicos/${idMedico}.${ext}`;
          try {
            const resp = await fetch(url, { method: 'HEAD' });
            if (resp.ok) {
              setFotoPreview(url);
              return;
            }
          } catch (_) {
            // continuar con siguiente intento
          }
        }
      }
      // Si no se encontró, mantener avatar por defecto
      setFotoPreview(null);
    } catch (err) {
      setFotoPreview(null);
    } finally {
      setCargandoFoto(false);
    }
  };

  const handleEdit = (m) => {
    setEditId(m.id);
    setForm({
      oid_medico: m.oid_medico || '',
      iden: m.iden || '',
      nombre: m.nombre || '',
      formacion: m.formacion || '',
      especialidad: m.especialidad || '',
      experiencia: m.experiencia || '',
      resenas: m.resenas || '',
      estado: m.estado || 0
    });
    // Resetear estados de foto y errores al abrir
    setErrorFoto(null);
    setSubiendoFoto(false);
    setFotoPreview(null);
    setModalOpen(true);
    // Intentar cargar imagen guardada
    if (m.id) {
      cargarFotoGuardada(m.iden);
    }
  };

  const handleCreate = () => {
    setEditId(null);
    setForm({
      oid_medico: '',
      iden: '',
      nombre: '',
      formacion: '',
      especialidad: '',
      experiencia: '',
      resenas: '',
      telefono: '',
      estado: 0
    });
    setErrorFoto(null);
    setSubiendoFoto(false);
    setFotoPreview(null);
    setModalOpen(true);
  };

  return (
    <div style={cajaPrincipalStyle}>
      <LoadingOverlay visible={procesando || cargandoFoto || subiendoFoto} />
      <TituloAdmin
        titulo="Administración de Médicos"
        imagen_titulo="medi"
        subtitulo="Gestión y visualización de información de médicos"
      />
      {/* Div central */}
      <div style={cajaContenedorAdminStyle}>
        {error && <div style={alertStyle('error')}>{error}</div>}

        {cargando ? (<LabelCarga nombre="médicos" />) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '2vh' }}>
              <Boton
                label="Agregar Médico"
                onClick={handleCreate}
                color={colors.primary}
                ancho="20vh"
                alto="5vh"
              />
            </div>

            <div style={{ marginBottom: '2vh', display: 'flex', gap: '2vh' }}>
              <div>
                <Label>Buscar Médico</Label>
                <Input
                  placeholder='Buscar por nombre...'
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && cargarMedicos()}
                  onIconClick={cargarMedicos}
                  ancho='30vh'
                  icono='buscar'
                />
              </div>
              <div>
                <Label>Buscar por Empresa</Label>
                <Input
                  placeholder='Buscar por empresa...'
                  value={busquedaEmpresa}
                  onChange={(e) => setBusquedaEmpresa(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && cargarMedicos()}
                  onIconClick={cargarMedicos}
                  ancho='30vh'
                  icono='buscar'
                />
              </div>
              <div>
                <Label>Buscar por Especialidad</Label>
                <Input
                  placeholder='Buscar por especialidad...'
                  value={busquedaEspecialidad}
                  onChange={(e) => setBusquedaEspecialidad(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && cargarMedicos()}
                  onIconClick={cargarMedicos}
                  ancho='30vh'
                  icono='buscar'
                />
              </div>
              <div>
                <Label>Filtrar por Asignación</Label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1vh' }}>
                  <div style={{ minWidth: '30vh', maxWidth: '100%', flex: '0 1 34vh' }}>
                  <select
                    ref={filtroAsignacionSelectRef}
                    value={filtroSinEspecialidad}
                    onChange={(e) => setFiltroSinEspecialidad(e.target.value)}
                    style={selectStyle}
                  >
                    <option value="todos">Todos</option>
                    <option value="sin_especialidad">Sin Especialidad</option>
                    <option value="incompletos">Sin Foto/Perfil/Exp</option>
                  </select>
                  </div>
                  <span style={{ fontFamily: 'Inter', fontSize: '1.8vh', color: colors.gray600, fontWeight: 'bold' }}>
                    Total: {medicos.length}
                  </span>
                </div>
              </div>
            </div>
            <div className="modern-table-container">
              <table id="medicosTable" ref={tablaRef} className="modern-table">
                <thead>
                  <tr>
                    <th style={{ width: '5vh', textAlign: 'center' }}>#</th>
                    <th>Nombre</th>
                    <th>Especialidad</th>
                    <th style={{ textAlign: 'center' }}>Estado</th>
                    <th style={{ textAlign: 'center' }}>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {medicos.filter(m => {
                    const nombreMatch = !busqueda || (m.nombre || '').toLowerCase().includes(busqueda.toLowerCase());
                    const espMatch = !busquedaEspecialidad || (m.especialidad || '').toLowerCase().includes(busquedaEspecialidad.toLowerCase());
                    
                    let empresaMatch = true;
                    if (busquedaEmpresa) {
                      const term = busquedaEmpresa.toLowerCase();
                      if (!m.especialidad) {
                        empresaMatch = false;
                      } else {
                        const misEsp = m.especialidad.split(',').map(s => s.trim().toLowerCase());
                        empresaMatch = misEsp.some(miEspName => {
                          return especialidades.some(opt => {
                            const optLabel = opt.label.toLowerCase();
                            const isMyEsp = optLabel === miEspName || optLabel.startsWith(miEspName + ' -');
                            return isMyEsp && optLabel.includes(term);
                          });
                        });
                      }
                    }

                    let sinEspMatch = true;
                    if (filtroSinEspecialidad === 'sin_especialidad') {
                      sinEspMatch = !m.especialidad || m.especialidad.trim() === '';
                    } else if (filtroSinEspecialidad === 'incompletos') {
                      const sinFoto = !m.foto || Number(m.foto) !== 1;
                      const sinResenas = !m.resenas || m.resenas.trim() === '';
                      const sinExp = !m.experiencia || m.experiencia.trim() === '';
                      sinEspMatch = sinFoto || sinResenas || sinExp;
                    }

                    return nombreMatch && espMatch && empresaMatch && sinEspMatch;
                  }).map((m, index) => (
                    <tr key={m.id}>
                      <td style={{ textAlign: 'center', fontWeight: 'bold' }}>{index + 1}</td>
                      <td>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.8vh' }}>
                          {m.nombre || ''}
                          {Number(m.foto) === 1 && (
                            <PhotoCamera
                              style={{ fontSize: '4vh', color: colors.primary }}
                              titleAccess="Foto registrada"
                            />
                          )}
                          {m.experiencia && m.resenas && m.experiencia.trim() !== '' && m.resenas.trim() !== '' && (
                            <CheckIcon
                              style={{ fontSize: '2vh', color: colors.success }}
                              titleAccess="Información completa (Experiencia y Perfil)"
                            />
                          )}
                        </span>
                      </td>
                      <td>
                        <SpecialtySelect
                          initialValue={m.especialidad}
                          options={especialidades}
                          onSave={(selectedOptions) => handleSpecialtyChange(m, selectedOptions)}
                        />
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {m.estado === 0 ? (
                          <CheckCircleIcon style={{ color: colors.success, fontSize: '2.5vh' }} titleAccess="Activo" />
                        ) : (
                          <CancelIcon style={{ color: colors.errorText, fontSize: '2.5vh' }} titleAccess="Inactivo" />
                        )}
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', gap: '1vh', justifyContent: 'center' }}>
                          <BotonIconoTabla
                            icono="edit"
                            tooltipText="Editar"
                            onClick={() => handleEdit(m)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: 'right', marginTop: '1.5vh' }}>
              <Boton
                label={"Descargar Excel"}
                onClick={descargarExcel}
                disabled={cargando || !Array.isArray(medicos) || medicos.length === 0}
                color={colors.primary}
                ancho="25vh"
                alto="5vh"
              />
            </div>
          </>
        )}
      </div>
      {/* Modal de edición de médico */}
      <Dialog id="edicionMedico" open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle style={{ fontFamily: 'Inter', fontWeight: 700 }}>{editId ? 'Editar Médico' : 'Agregar Médico'}</DialogTitle>
        <DialogContent dividers>
          {/* Fila 1: Izquierda nombre/especialidad, Derecha captura imagen */}
          <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: '2vh', alignItems: 'start' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.6vh' }}>
              <TextField
                fullWidth
                label="Nombre"
                value={form.nombre}
                onChange={(e) => setForm((prev) => ({ ...prev, nombre: e.target.value }))}
                InputLabelProps={{ style: { fontFamily: 'Inter' } }}
                inputProps={{ style: { fontFamily: 'Inter' } }}
              />
              <TextField
                fullWidth
                label="Identificación"
                value={form.iden}
                onChange={(e) => setForm((prev) => ({ ...prev, iden: e.target.value }))}
                InputLabelProps={{ style: { fontFamily: 'Inter' } }}
                inputProps={{ style: { fontFamily: 'Inter' } }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Label style={{ fontSize: '1.6vh', marginBottom: '1vh' }}>Foto del médico</Label>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handlePhotoChange}
                disabled={subiendoFoto}
                style={{ display: 'none' }}
              />
              <div
                onClick={() => !subiendoFoto && fileInputRef.current && fileInputRef.current.click()}
                title={subiendoFoto ? 'Subiendo...' : 'Subir foto (clic)'}
                style={{
                  width: '18vh',
                  height: '18vh',
                  borderRadius: '50%',
                  backgroundColor: colors.primary,
                  color: colors.white,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: subiendoFoto ? 'not-allowed' : 'pointer',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: `0 0.4vh 1.2vh ${colors.tableShadow}`,
                }}
              >
                {fotoPreview ? (
                  <img
                    src={fotoPreview}
                    alt="Preview"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <PhotoCamera style={{ fontSize: '4vh', color: colors.white }} />
                    <span style={{ fontSize: '1.6vh', fontFamily: 'Inter', marginTop: '0.6vh' }}>Subir foto</span>
                  </div>
                )}
                {subiendoFoto && (
                  <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.2)' }} />
                )}
              </div>
              {errorFoto && (
                <div style={{ color: colors.errorText, fontFamily: 'Inter', fontSize: '1.4vh', marginTop: '1vh' }}>{errorFoto}</div>
              )}
            </div>
          </div>

          {/* Fila 2: Experiencia */}
          <div style={{ marginTop: '2vh' }}>
            <TextField
              fullWidth
              label="Años de experiencia"
              value={form.experiencia}
              onChange={(e) => setForm((prev) => ({ ...prev, experiencia: e.target.value }))}
              InputLabelProps={{ style: { fontFamily: 'Inter' } }}
              inputProps={{ style: { fontFamily: 'Inter' } }}
            />
          </div>

          {/* Fila 3: Perfil profesional al 100% */}
          <div style={{ marginTop: '2vh' }}>
            <TextField
              fullWidth
              label="Perfil profesional"
              value={form.resenas}
              onChange={(e) => setForm((prev) => ({ ...prev, resenas: e.target.value }))}
              multiline
              minRows={4}
              InputLabelProps={{ style: { fontFamily: 'Inter' } }}
              inputProps={{ style: { fontFamily: 'Inter' } }}
            />
          </div>
          
          <div style={{ marginTop: '2vh', display: 'flex', alignItems: 'center', gap: '1vh' }}>
            <Label>Estado del médico:</Label>
            <select
              name="estado"
              value={form.estado}
              onChange={(e) => setForm((prev) => ({ ...prev, estado: Number(e.target.value) }))}
              style={{
                padding: '0.8vh',
                borderRadius: '0.6vh',
                border: `1px solid ${colors.gray400}`,
                fontFamily: 'Inter',
                fontSize: '1.6vh',
                color: colors.primaryText,
                outline: 'none',
                cursor: 'pointer'
              }}
            >
              <option value={0}>Activo</option>
              <option value={1}>Inactivo</option>
            </select>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => setModalOpen(false)}
            style={{
              backgroundColor: colors.gray200,
              color: colors.primaryText,
              border: 'none',
              borderRadius: '6px',
              padding: '0.5rem 1rem',
              fontSize: '1.6vh',
              fontFamily: 'Inter',
              cursor: 'pointer'
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            disabled={procesando}
            style={{
              backgroundColor: colors.primary,
              color: colors.white,
              border: 'none',
              borderRadius: '6px',
              padding: '0.5rem 1rem',
              fontSize: '1.6vh',
              fontFamily: 'Inter',
              fontWeight: '600',
              cursor: procesando ? 'not-allowed' : 'pointer'
            }}
          >
            {procesando ? 'Guardando...' : 'Guardar'}
          </button>
        </DialogActions>
      </Dialog>
      {/* Modal de éxito */}
      <Dialog open={exitoModalOpen} onClose={() => { setExitoModalOpen(false); }} fullWidth maxWidth="xs">
        <DialogTitle style={{ fontFamily: 'Inter', fontWeight: 700 }}>Éxito</DialogTitle>
        <DialogContent dividers>
          <div style={{ fontFamily: 'Inter', fontSize: '1.6vh' }}>
            {exito}
          </div>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => { setExitoModalOpen(false); setExito(null); }}
            style={{
              backgroundColor: colors.primary,
              color: colors.white,
              border: 'none',
              borderRadius: '6px',
              padding: '0.5rem 1rem',
              fontSize: '1.6vh',
              fontFamily: 'Inter',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Aceptar
          </button>
        </DialogActions>
      </Dialog>
      <Notify
        open={notification.open}
        message={notification.message}
        type={notification.type}
        onClose={handleCloseNotification}
      />
      <LoadingOverlay visible={cargando || procesando || subiendoFoto || cargandoFoto || renderingTable} />
    </div>
  );
}

export default Medicos;